// Accueil d'un compte citoyen (P02) : le portail public est une fonctionnalité activable, désactivée par
// défaut. Tant qu'elle l'est, une page d'indisponibilité sobre, sans aucune donnée publiée.

import { useQuery } from '@tanstack/react-query';
import { api } from '../../api/client';
import { useAPropos } from '../../api/requetes';
import { MessageErreur, Squelette } from '../../composants/Etats';

export function AccueilPublic() {
  const f = useQuery({
    queryKey: ['fonctionnalites'],
    queryFn: async () => (await api<{ code: string; libelle: string; active: boolean }[]>('/api/v1/fonctionnalites')).donnees,
  });
  const aPropos = useAPropos();
  if (f.isLoading) return <Squelette lignes={3} />;
  if (f.error) return <MessageErreur erreur={f.error} />;
  const portail = f.data?.find((x) => x.code === 'portail_public');
  return (
    <div className="accueil-public">
      {aPropos.data?.environnement.mention && (
        <p className="note ambre">
          {aPropos.data.environnement.mention}. Dans cet environnement, le portail est {portail?.active ? 'activé' : 'désactivé'} par l’administrateur fonctionnel.
        </p>
      )}
      {portail?.active ? (
        <section className="carte-bloc portail-ferme" aria-labelledby="titre-portail">
          <h1 id="titre-portail">Portail public</h1>
          <p className="attenue">Le portail est activé ; ses écrans de consultation (stations participantes, horaires, disponibilité par produit) seront ouverts avec le module du portail public (lot 6).</p>
        </section>
      ) : (
        <section className="carte-bloc portail-ferme" aria-labelledby="titre-portail">
          <h1 id="titre-portail">Le portail public est momentanément fermé</h1>
          <p className="attenue">Aucune donnée n’est publiée pour le moment. Pour toute question sur l’approvisionnement en carburant, contactez la mairie ou la préfecture de votre province.</p>
        </section>
      )}
    </div>
  );
}
